import React, { useState } from "react";
import {
  makeStyles,
  Typography,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import ProductDetails from "./productdetails";
import TestSection from "./TestSection";
import YearFilter from "./YearFilter";
import PreviousYearPapers from "./PreviousYearPapers";
import YearFilterMobile from "./YearFilterMobile";
import PreviousYearPapersMobile from "./PreviousYearPapersMobile";

const useStyles = makeStyles((theme) => ({
  flexContainer: {
    display: "flex",
    marginTop: "2rem",
  },
  container2: {
    padding: "1.5rem 1rem",
    marginTop: "2rem",
    display: "flex",
    color: "#727272",
    fontSize: "16px",
    background: "#FFFFFF",
    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.06)",
    [theme.breakpoints.down("xs")]: {
      background: "none",
      display: "block",
      padding: "2.5rem 1rem",
    },

    "& .MuiToggleButton-root.Mui-selected": {
      color: "#FF3939",
      background: "#FFFFFF",
    },
    "& .MuiToggleButton-root": {
      color: "#777777",
      background: "#FFFFFF",
      borderRadius: "40px",
      padding: "0.5rem",
      position: "absolute",
      right: "16px",
      top: "16px",
    },
    "& .MuiIconButton-label": {
      fontSize: "1rem",
      fontFamily: "Jost",
      fontWeight: "400",
      textTransform: "uppercase",
      [theme.breakpoints.down("xs")]: {
        fontSize: "0.875rem",
      },
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1.3rem",
    },
    "& .MuiButton-contained": {
      boxShadow: "none",
    },
  },
  containerfluid: {
    width: "100%",
    margin: "auto",
    background: "#FFFCF4",
    padding: "1rem",
    paddingBottom:'0px'
  },
  container: {
    maxWidth: "1250px",
    margin: "0 auto 12rem",
    "& .MuiAppBar-colorPrimary": {
      background: "none",
      color: "#000000",
    },
  },
  descriptionContainer: {
    padding: "1.5rem",
    marginTop: "1rem",
    color: "#727272",
    fontSize: "16px",
    background: "#FFFFFF",
    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.06)",
    borderRadius: "8px",
    [theme.breakpoints.down("sm")]: {
      padding: "1rem",
      fontSize: "14px",
    },
  },
  flexContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: "2rem",
    gap: "1.5rem",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center",
    },
  },
  filterSection: {
    width: "250px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  contentSection: {
    flex: 1,
    width: "100%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
}));

function SinglePageContent({ previousyearpaperDetail }) {
  const classes = useStyles();
  const theme = useTheme(); // Moved to the top
  const isMobile = useMediaQuery(theme.breakpoints.down("xs")); // Moved to the top
  const [selectedYear, setSelectedYear] = useState([]);

  if (!previousyearpaperDetail) return null;

  const uniqueYears1 = [
    ...new Set(
      previousyearpaperDetail?.previous_year_papers?.map((paper) => paper.year)
    ),
  ];
  const uniqueYears2 = [
    ...new Set(previousyearpaperDetail?.pdf_papers?.map((paper) => paper.year)),
  ];
  const uniqueYears = [...new Set([...uniqueYears1, ...uniqueYears2])];

  const filteredYears =
    selectedYear.length > 0
      ? uniqueYears.filter((year) => selectedYear.includes(year))
      : uniqueYears;

  return (
    <div className={classes.containerfluid}>
      <div className={classes.container}>
        <ProductDetails previousyearpaperDetail={previousyearpaperDetail} type={'Previous Year Paper'} />

        <div className={classes.descriptionContainer}>
          <Typography variant="body2">
            {previousyearpaperDetail?.description}
          </Typography>
        </div>

        <div className={classes.flexContainer}>
          <div className={classes.filterSection}>
            {isMobile ? (
              <YearFilterMobile
                uniqueYears={uniqueYears}
                setSelectedYear={setSelectedYear}
                selectedYear={selectedYear}
              />
            ) : (
              <YearFilter
                uniqueYears={uniqueYears}
                setSelectedYear={setSelectedYear}
                selectedYear={selectedYear}
              />
            )}
          </div>

          <div className={classes.contentSection}>
            {filteredYears.map((year) => (
              <TestSection
                key={year}
                data={year}
                previousyearpaperDetail={previousyearpaperDetail}
                selectedYear={selectedYear}
              />
            ))}

            {isMobile ? (
              <PreviousYearPapersMobile previousyearpaperDetail={previousyearpaperDetail} />
            ) : (
              <PreviousYearPapers
                previousyearpaperDetail={previousyearpaperDetail}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SinglePageContent;
